import AbstractScene from './AbstractScene.js';
import UI from './UI.js';

export default class Preloader extends AbstractScene {

    constructor() {
        super({
            key: "Preloader"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();

        // Ajout du texte de chargement
        this.loadingText = this.make.text({
            x: this.width / 2,
            y: this.height / 2,
            text: 'Chargement... 0%',
            style: {
                font: '60px MassiliaMedium',
                fill: '#000000',
                stroke: '#FFF',
                strokeThickness: 8
            }
        });

        this.loadingText.setOrigin(0.5, 0.5);

        this.loadSprites();

        this.load.on('progress', (value) => {
            // this.chargement.setScale(value, 1);
            this.loadingText.text = 'Chargement... ' + Math.floor(value * 100) + '%';
        });
        
        // this.load.on('fileprogress', function (file) {
            // console.log(file.src);
        // });

        this.load.on('complete', function () {
            // this.scene.add('UI', UI, true);
            this.nextScene();
        }, this);
    }

    loadSprites() { 
               this.load.html('videoPlayer', 'assets/videos/video.html');

        this.load.image('intro', "assets/images/menu/image-menu.jpg")
        this.load.image('mqde', "assets/images/menu/mqde.png")
        this.load.image('rectIntro', "assets/images/menu/rect_menu.png")
        this.load.image('logoABC', "assets/images/menu/logo_abc.png")
        this.load.image('logoMQDE', "assets/images/menu/logo_mqde_couleur.png")
        this.load.image('logoBDF', "assets/images/menu/logo_bdf.png")
        this.load.image('logoSydo', "assets/images/menu/logo_sydo.png")
        this.load.image('backFin', 'assets/images/menu/back_fin.png')
        this.load.image('backLine', 'assets/images/menu/back_line.png')

        
        this.load.image('background', 'assets/images/schema/background.png')
        this.load.image('imgPlaceholder', 'assets/images/schema/img-placeholder.png')
        this.load.image('badAnswer', 'assets/images/schema/bad-answer.png')
        this.load.image('goodAnswer', 'assets/images/schema/good-answer.png')
        this.load.image('plus', 'assets/images/schema/plus.png')

        this.load.image('logoLinkedin', 'assets/images/menu/logo_linkedin.png')
        

        
        this.load.image('prod',"assets/images/schema/items/prod.png")
        this.load.image('prodBlack',"assets/images/schema/items/prod-black.png")

        this.load.image('matieres',"assets/images/schema/items/matieres.png")
        this.load.image('matieresBlack',"assets/images/schema/items/matieres-black.png")
        this.load.image('marchandise',"assets/images/schema/items/marchandise.png")
        this.load.image('marchandiseBlack',"assets/images/schema/items/marchandise-black.png")
        this.load.image('energie',"assets/images/schema/items/energie.png")
        this.load.image('energieBlack',"assets/images/schema/items/energie-black.png")
        this.load.image('sousTraitance',"assets/images/schema/items/sous-traitance.png")
        this.load.image('sousTraitanceBlack',"assets/images/schema/items/sous-traitance-black.png")

        this.load.image('salaire',"assets/images/schema/items/salaire.png")
        this.load.image('salaireBlack',"assets/images/schema/items/salaire-black.png")
        this.load.image('impots',"assets/images/schema/items/impots.png")
        this.load.image('impotsBlack',"assets/images/schema/items/impots-black.png")

        this.load.image('usure',"assets/images/schema/items/usure.png")
        this.load.image('usureBlack',"assets/images/schema/items/usure-black.png")
        this.load.image('obsolescence',"assets/images/schema/items/obsolescence.png")
        this.load.image('obsolescenceBlack',"assets/images/schema/items/obsolescence-black.png")

        this.load.image('resultat',"assets/images/schema/items/resultat.png")
        this.load.image('resultatBlack',"assets/images/schema/items/resultat-black.png")
        
        this.load.image('venteImmoBlack',"assets/images/schema/items/vente-immo-black.png")
        this.load.image('venteImmo',"assets/images/schema/items/vente-immo.png")
        
        
        this.load.image('labelPlaceholder','assets/images/schema/label-placeholder.png') 
        
        this.load.image('exploitation','assets/images/schema/labels/exploitation.png') 
        this.load.image('zoneExploitation','assets/images/schema/zones/zoneExploitation.png') 
        this.load.image('zoneExploitationFull','assets/images/schema/zones/zoneExploitationFull.png') 
        this.load.image('investissement','assets/images/schema/labels/investissment.png')
        this.load.image('zoneInvestissement','assets/images/schema/zones/zoneInvestissement.png') 
        this.load.image('zoneInvestissementFull','assets/images/schema/zones/zoneInvestissementFull.png')
        this.load.image('financement','assets/images/schema/labels/financement.png') 
        this.load.image('zoneFinancement','assets/images/schema/zones/zoneFinancement.png') 
        this.load.image('zoneFinancementFull','assets/images/schema/zones/zoneFinancementFull.png') 

        this.load.image('goodBox','assets/images/schema/good-box.png')
        this.load.image('badBox','assets/images/schema/bad-box.png')

    }
}